export const reasons = [
  { label: 'Morning break', key: 'MORNING_BREAK' },
  { label: 'Lunch break', key: 'LUNCH_BREAK' },
  { label: 'Meeting', key: 'MEETING' },
  { label: 'Evening break', key: 'EVENING_BREAK' },
  { label: 'Training', key: 'TRAINING' },
  { label: 'Others', key: 'OTHERS' }
];

export interface AgentDocumentData {
  documentRefId: string;
  uri: string;
  unSignedUri: string | null;
  docContentType: string;
  language: string;
  documentType: string;
  documentName: string;
  documentCategory: string;
  languagesAvailable: string[];
  downloadable: boolean;
  multiLingual: boolean;
  dynamicallyGenerated: boolean;
  viewable: boolean;
}

export interface IUserDocument {
  document: AgentDocumentData;
  isLastDocument: boolean;
}

export enum AGENT_DOCUMENT_TYPE {
  DRA_CERTIFICATE = 'DRA_CERTIFICATE',
  NDRA_CERTIFICATE = 'NDRA_CERTIFICATE'
}

export const DOCUMENTS_MAP = {
  [AGENT_DOCUMENT_TYPE.DRA_CERTIFICATE]: true,
  [AGENT_DOCUMENT_TYPE.NDRA_CERTIFICATE]: true
};

export enum SideNavKeys {
  CASES_AGENT_VIEW = 'CASES_AGENT_VIEW',
  CASES_TEAM_LEAD_VIEW = 'CASES_TEAM_LEAD_VIEW',
  DASHBOARD_AGENT_VIEW = 'DASHBOARD_AGENT_VIEW',
  CSA_DASHBOARD = 'CSA_DASHBOARD',
  EXTERNAL_DASHBOARD = 'EXTERNAL_DASHBOARD',
  ANOMALY_TRACKER = 'ANOMALY_TRACKER',
  FIELD_SUPPORT = 'FIELD_SUPPORT',
  ID_CARD_APPROVALS = 'ID_CARD_APPROVALS',
  AGENTS_STATUS = 'AGENTS_STATUS',
  AMEYO_PASSWORD = 'AMEYO_PASSWORD',
  AMEYO_UTILITY = 'AMEYO_UTILITY',
  WHATSAPP_CHAT = 'WHATSAPP_CHAT',
  ALLOCATION = 'ALLOCATION',
  AVAILABILITY_TRACKER = 'AVAILABILITY_TRACKER',
  USER_MANAGEMENT = 'USER_MANAGEMENT',
  HR_DASHBOARD = 'HR_DASHBOARD',
  ENACH = 'ENACH',
  AGENCY_MANAGEMENT = 'AGENCY_MANAGEMENT',
  PARAMOUNT = 'PARAMOUNT',
  STATE_RESETTER = 'STATE_RESETTER',
  AGENCY_OPERATIONS = 'AGENCY_OPERATIONS',
  NAVI_ICON = 'NAVI_ICON',
  ONLINE_TOGGLE = 'ONLINE_TOGGLE',
  LOGOUT = 'LOGOUT',
  AMEYO_TOOLBAR = 'AMEYO_TOOLBAR',
  NOTIFICATIONS_COUNT = 'NOTIFICATIONS_COUNT',
  ONLINE_OFFLINE_SWITCH = 'ONLINE_OFFLINE_SWITCH',
  SWITCH = 'SWITCH',
  TOOLTIP_CIRCULAR_PROGRESS = 'TOOLTIP_CIRCULAR_PROGRESS'
}

export enum SideNavPaths {
  CASES_AGENT_VIEW = 'Cases',
  CASES_TEAM_LEAD_VIEW = 'Cases',
  DASHBOARD_AGENT_VIEW = 'Dashboard',
  CSA_DASHBOARD = 'Dashboard',
  EXTERNAL_DASHBOARD = 'Dashboard',
  ANOMALY_TRACKER = 'Anomaly Tracker',
  FIELD_SUPPORT = 'Field Support',
  ID_CARD_APPROVALS = 'Approvals',
  AGENTS_STATUS = 'Agents Status',
  AMEYO_PASSWORD = 'Ameyo Password',
  AMEYO_UTILITY = 'Ameyo Utility',
  WHATSAPP_CHAT = 'Whatsapp Chat',
  ALLOCATION = 'Allocation',
  AVAILABILITY_TRACKER = 'Availability Tracker',
  USER_MANAGEMENT = 'User Management',
  HR_DASHBOARD = 'Performance Dashboard',
  ENACH = 'E-NACH',
  AGENCY_MANAGEMENT = 'Agency Management',
  PARAMOUNT = 'Paramount',
  STATE_RESETTER = 'State Resetter',
  AGENCY_OPERATIONS = 'Agency Operations'
}

export enum SideNavComponents {
  AMEYO_TOOLBAR = 'Ameyo Toolbar',
  NOTIFICATIONS_COUNT = 'Notifications Count',
  ONLINE_OFFLINE_SWITCH = 'Online Offline Switch',
  SWITCH = 'Switch',
  TOOLTIP_CIRCULAR_PROGRESS = 'Tooltip Circular Progress'
}

export enum SideNavButtons {
  NAVI_ICON = 'Navi Icon',
  ONLINE_TOGGLE = 'Online Toggle',
  LOGOUT = 'Logout'
}

export enum FeatureFlags {
  CSA_DASHBOARD_VISIBLE = 'csaDashboardVisible',
  PERFORMANCE_DASHBOARD = 'performanceDashboard',
  EXTERNAL_AGENCY_PERFORMANCE_DASHBOARD = 'externalAgencyPerformanceDashboard',
  AGENCY_PAGE_ACCESS = 'agencyPageAccess',
  AGENCY_CAPPING_ENABLED = 'agencyCappingEnabled',
  AGENCY_SERVICEABILITY = 'agencyServiceability',
  IS_AMEYO_UTILITY_VISIBLE = 'isAmeyoUtilityVisible',
  ENACH_PROCESSING_ENABLED = 'enachProcessingEnabled',
  IS_AGENT_ID_CARD_DETAILS_VISIBLE = 'isAgentIdCardDetailsVisible',
  PAN_CARD_APPROVAL_FLOW = 'panCardApprovalFlow',
  ENABLE_ANOMALY_TRACKER = 'enableAnomalyTracker',
  CSA_CO_ORDINATION_MODULE_FEATURE_FLAG = 'csaCoOrdinationModuleFeatureFlag',
  AMEYO_GENERATE_PASSWORD_FLAG = 'ameyoGeneratePasswordFlag',
  AMEYO_SELF_SERVE_FLAG = 'ameyoSelfServeFlag',
  THIRD_PARTY_ADDRESS_INGESTION = 'thirdPartyAddressIngestion'
}

export const CLICK_CONFIG = {
  REQUIRED_CLICKS: 3,
  TIME_WINDOW: 1000 // 1 second in milliseconds
};
